import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "m-t-10 table_90 border-r-10 text-black"
};
const _hoisted_2 = {
  class: "bg_white table_90 m-t-10 border-r-10 text-black f-12"
};
const _hoisted_3 = ["src", "onMousemove", "onMouseout"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_row = _resolveComponent("el-row");
  const _component_plus = _resolveComponent("plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_input = _resolveComponent("el-input");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_option = _resolveComponent("vxe-option");
  const _component_vxe_select = _resolveComponent("vxe-select");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_main = _resolveComponent("el-main");
  const _directive_allow = _resolveDirective("allow");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8,
        style: {
          "align-items": "center",
          "display": "flex",
          "flex-direction": "row"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: $options.save
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("保存修改")])),
          _: 1,
          __: [12]
        }, 8, ["onClick"])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 16,
        class: "text-r"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          style: {
            "border": "0",
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: "",
            "auto-upload": false,
            multiple: false,
            "show-file-list": false,
            "on-change": $options.uploadByJsqd,
            "file-list": $data.fileList
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "mini"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("导入")])),
              _: 1,
              __: [13]
            })]),
            _: 1
          }, 8, ["on-change", "file-list"])]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: $options.batchExport
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("导出")])),
          _: 1,
          __: [14]
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: $options.clickLog
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("日志")])),
          _: 1,
          __: [15]
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: $options.synchronizeErp
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("同步ERP数据")])),
          _: 1,
          __: [16]
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_vxe_table, {
      border: "",
      resizable: "",
      "show-overflow": "",
      height: $data.tableHeight,
      "scroll-x": {
        enabled: false
      },
      "scroll-y": {
        enabled: false
      },
      "header-row-style": $data.header_style,
      data: $data.tableData,
      "edit-config": $options.editConfig
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_colgroup, {
        title: "基本信息",
        "header-align": "center",
        fixed: "left",
        resizable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "picture",
          title: "图片",
          width: "80",
          "header-align": "center",
          align: "center",
          class: "position-r"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_upload, {
            action: $options.api_upload_url,
            "with-credentials": true,
            "on-success": function (res, file, file_list) {
              return $options.handleSuccess(res, file, file_list, row);
            },
            "show-file-list": false,
            name: "file",
            accept: ".png, .jpg",
            "on-change": $options.handleChange
          }, {
            default: _withCtx(() => [row.picture ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: row.picture,
              class: "avatar",
              onMousemove: $event => $options.enlarge($event, row),
              onMouseout: $event => $options.enlargeOut(row)
            }, null, 40, _hoisted_3)) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_plus)]),
              _: 1
            })), $data.enlargeImg ? _withDirectives((_openBlock(), _createElementBlock("view", {
              key: 2,
              class: "img-show position-f",
              style: _normalizeStyle($data.top)
            }, [_createElementVNode("img", {
              src: $data.enlargeImg
            }, null, 8, _hoisted_4)], 4)), [[_vShow, row.enlargeImgShow]]) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["action", "on-success", "on-change"])]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "规格型号（sku）",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "model",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_input, {
              size: "mini",
              modelValue: $data.form_requst.model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form_requst.model = $event),
              onKeydown: _withKeys($options.getList, ["enter", "native"])
            }, null, 8, ["modelValue", "onKeydown"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "产品名称",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "name",
            width: "120",
            "header-align": "center"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_input, {
              size: "mini",
              modelValue: $data.form_requst.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form_requst.name = $event),
              onKeydown: _withKeys($options.getList, ["enter", "native"])
            }, null, 8, ["modelValue", "onKeydown"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "生命周期",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "F_PAEZ_Combo2",
            width: "100",
            "header-align": "center"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.form_requst.F_PAEZ_Combo2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form_requst.F_PAEZ_Combo2 = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[3] || (_cache[3] = $event => $options.clear('F_PAEZ_Combo2'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.F_PAEZ_Combo2, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item,
                  value: item,
                  onClick: $options.getList
                }, null, 8, ["label", "value", "onClick"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "产品分类",
        "header-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_colgroup, {
          title: "一级分类",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "category_one",
            width: "100"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.form_requst.category_one,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form_requst.category_one = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[5] || (_cache[5] = $event => $options.clear('category_one')),
              ref: "select_one"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.category_one, (item1, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item1,
                  value: item1,
                  onClick: $options.getList
                }, null, 8, ["label", "value", "onClick"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "二级分类",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "category_two",
            width: "100"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.form_requst.category_two,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form_requst.category_two = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[7] || (_cache[7] = $event => $options.clear('category_two'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.category_two, (item2, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item2,
                  value: item2,
                  onClick: $options.getList
                }, null, 8, ["label", "value", "onClick"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "三级分类",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "category_three",
            width: "100"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.form_requst.category_three,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form_requst.category_three = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[9] || (_cache[9] = $event => $options.clear('category_three'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.category_three, (item3, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item3,
                  value: item3,
                  onClick: $options.getList
                }, null, 8, ["label", "value", "onClick"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        "header-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_colgroup, {
          title: "项目负责团队",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "team_user",
            width: "100",
            "header-align": "center"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.form_requst.team_user,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form_requst.team_user = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[11] || (_cache[11] = $event => $options.clear('team_user'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.opd_list, (items, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: items,
                  value: items,
                  onClick: $options.getList
                }, null, 8, ["label", "value", "onClick"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _withDirectives(_createVNode(_component_vxe_column, {
        field: "cost",
        title: "物料成本价",
        width: "80",
        "header-align": "center",
        align: "right"
      }, null, 512), [[_directive_allow, 'NewCost.NewCostFinance']]), _createVNode(_component_vxe_column, {
        field: "factory_price",
        title: "出厂价(TCO成本)",
        width: "80",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.factory_price,
          "onUpdate:modelValue": $event => row.factory_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "agent_price",
        title: "代理价",
        width: "75",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.agent_price,
          "onUpdate:modelValue": $event => row.agent_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "retail_price",
        title: "零售指导价",
        width: "70",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.retail_price,
          "onUpdate:modelValue": $event => row.retail_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "minimum_activity_price",
        title: "最低活动价",
        width: "70",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.minimum_activity_price,
          "onUpdate:modelValue": $event => row.minimum_activity_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "overseas_retail_price",
        title: "海外零售指导价($)",
        width: "70",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.overseas_retail_price,
          "onUpdate:modelValue": $event => row.overseas_retail_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "overseas_minimum_activity_price",
        title: "海外零售最低活动价($)",
        width: "75",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.overseas_minimum_activity_price,
          "onUpdate:modelValue": $event => row.overseas_minimum_activity_price = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _withDirectives((_openBlock(), _createBlock(_component_vxe_colgroup, {
        title: "产品成本构成",
        "header-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "clinker_cost",
          title: "结构/本体",
          width: "70",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.clinker_cost,
            "onUpdate:modelValue": $event => row.clinker_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "metal_cost",
          title: "电子",
          width: "62",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.metal_cost,
            "onUpdate:modelValue": $event => row.metal_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "electron_cost",
          title: "电源",
          width: "62",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.electron_cost,
            "onUpdate:modelValue": $event => row.electron_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "wire_cost",
          title: "线材",
          width: "62",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.wire_cost,
            "onUpdate:modelValue": $event => row.wire_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "accessories_cost",
          title: "辅料/配件",
          width: "68",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.accessories_cost,
            "onUpdate:modelValue": $event => row.accessories_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "packing_cost",
          title: "包材",
          width: "62",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.packing_cost,
            "onUpdate:modelValue": $event => row.packing_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "process_cost",
          title: "加工费",
          width: "",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.process_cost,
            "onUpdate:modelValue": $event => row.process_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "other_cost",
          title: "硬盘/运费/其他/DDR",
          width: "80",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.other_cost,
            "onUpdate:modelValue": $event => row.other_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "auth_cost",
          title: "模具费/认证费等费用",
          width: "80",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.auth_cost,
            "onUpdate:modelValue": $event => row.auth_cost = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })]),
        _: 1
      })), [[_directive_allow, 'NewCost.NewCostFinance']]), _createVNode(_component_vxe_column, {
        field: "moq",
        title: "MOQ",
        width: "60",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.moq,
          "onUpdate:modelValue": $event => row.moq = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "packing",
        title: "包装方式",
        width: "80",
        "header-align": "center",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.packing,
          "onUpdate:modelValue": $event => row.packing = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "产品尺寸重量（mm/g）"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "FLENGTH",
          title: "长",
          width: "60",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.FLENGTH,
            "onUpdate:modelValue": $event => row.FLENGTH = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "FWIDTH",
          title: "宽",
          width: "60",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.FWIDTH,
            "onUpdate:modelValue": $event => row.FWIDTH = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "FHEIGHT",
          title: "高",
          width: "60",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.FHEIGHT,
            "onUpdate:modelValue": $event => row.FHEIGHT = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "FNETWEIGHT",
          title: "重量",
          width: "120",
          "header-align": "center",
          align: "right",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          }
        }, {
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.FNETWEIGHT,
            "onUpdate:modelValue": $event => row.FNETWEIGHT = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_colgroup, {
        title: "包装版本1",
        "header-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_colgroup, {
          title: "包装尺寸重量（mm/g）",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "FPACKAGE1",
            title: "包装版本名称",
            width: "60",
            "header-align": "center",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FPACKAGE1,
              "onUpdate:modelValue": $event => row.FPACKAGE1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FLENGTHP1",
            title: "长",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FLENGTHP1,
              "onUpdate:modelValue": $event => row.FLENGTHP1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FWIDTHP1",
            title: "宽",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FWIDTHP1,
              "onUpdate:modelValue": $event => row.FWIDTHP1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FHEIGHTP1",
            title: "高",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FHEIGHTP1,
              "onUpdate:modelValue": $event => row.FHEIGHTP1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FNETWEIGHTP1",
            title: "重量",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FNETWEIGHTP1,
              "onUpdate:modelValue": $event => row.FNETWEIGHTP1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "装箱信息(mm/Kg)",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "FQtyC1",
            title: "数量",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FQtyC1,
              "onUpdate:modelValue": $event => row.FQtyC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FLENGTHC1",
            title: "长",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FLENGTHC1,
              "onUpdate:modelValue": $event => row.FLENGTHC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FWIDTHC1",
            title: "宽",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FWIDTHC1,
              "onUpdate:modelValue": $event => row.FWIDTHC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FHEIGHTC1",
            title: "高",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FHEIGHTC1,
              "onUpdate:modelValue": $event => row.FHEIGHTC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FNETWEIGHTC1",
            title: "净重",
            width: "60",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FNETWEIGHTC1,
              "onUpdate:modelValue": $event => row.FNETWEIGHTC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "FGROSSWEIGHTC1",
            title: "毛重",
            width: "120",
            "header-align": "center",
            align: "right",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_input, {
              modelValue: row.FGROSSWEIGHTC1,
              "onUpdate:modelValue": $event => row.FGROSSWEIGHTC1 = $event,
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "report_spu",
        title: "报关SPU",
        width: "200",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.report_spu,
          "onUpdate:modelValue": $event => row.report_spu = $event,
          type: "text",
          maxlength: "100"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "FITEMPPROPERTY",
        title: "物料属性",
        width: "80",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "bom_version",
        title: "BOM版本",
        width: "140",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "remark1",
        title: "绩效提成经营分析品线(一级)",
        width: "80",
        "header-align": "center",
        align: "right"
      }, {
        default: _withCtx(({
          row
        }) => [_createTextVNode(_toDisplayString(row.remark1), 1)]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "remark2",
        title: "绩效提成经营分析品线(二级)",
        width: "100",
        "header-align": "center",
        align: "right",
        "edit-render": {}
      }, {
        default: _withCtx(({
          row
        }) => [_createTextVNode(_toDisplayString(row.remark2), 1)]),
        edit: _withCtx(({
          row,
          $rowIndex
        }) => [_createVNode(_component_vxe_select, {
          modelValue: row.remark2,
          "onUpdate:modelValue": $event => row.remark2 = $event,
          onChange: val => $options.updateRemark(val, $rowIndex),
          clearable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.remark_level, item => {
            return _openBlock(), _createBlock(_component_vxe_option, {
              key: item.remark_two,
              value: item.remark_two,
              label: item.remark_two
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "remark3",
        title: "业绩/回款统计品线",
        width: "80",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.remark3,
          "onUpdate:modelValue": $event => row.remark3 = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "line",
        title: "交付管理品线",
        width: "60",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.line,
          "onUpdate:modelValue": $event => row.line = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "is_fm",
        title: "是否闪存",
        width: "60",
        "header-align": "center",
        align: "right",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.is_fm,
          "onUpdate:modelValue": $event => row.is_fm = $event,
          type: "text"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "first_warehousing",
        title: "首批入库时间",
        width: "120",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "edit_time",
        title: "上次更新",
        width: "120",
        "header-align": "center",
        align: "right"
      })]),
      _: 1
    }, 8, ["height", "header-row-style", "data", "edit-config"]), _createVNode(_component_el_pagination, {
      "current-page": $data.form_requst.page,
      "page-sizes": [10, 20, 30],
      "page-size": $data.form_requst.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: $data.count,
      class: "m-t-10 m-b-20 table_90",
      onSizeChange: $options.handleSizeChange,
      onCurrentChange: $options.handleCurrentChange
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])]),
    _: 1
  });
}